import { formatterCurrencyTruncated } from '@/utilities/format';
import { toCurrencyTruncated, toTruncated } from '@/utilities/formatting';
import { shouldConvertCurrency } from '../../utils/currencyConversion';

export type CalculationBreakDownOutput = {
  fairValueReportedPrice: number;
  futureMarketCapitalisation: number;
  futureEarnings: number;
  sharePriceFutureYear: number;
  futureSharesOutstanding: number;
  exchangeRate: number;
  fairValueListedPrice: number;
  timeFrame: number;
};

export const toViewFormat = ({
  calculationBreakDownOutput,
  currentYear,
  listingCurrencyISO,
  reportingCurrencyISO,
}: {
  calculationBreakDownOutput: CalculationBreakDownOutput;
  currentYear: number;
  listingCurrencyISO: string;
  reportingCurrencyISO: string;
}) => {
  const currencyISO = shouldConvertCurrency({
    listingCurrencyISO,
    reportingCurrencyISO,
  })
    ? reportingCurrencyISO
    : listingCurrencyISO;

  const {
    fairValueReportedPrice,
    fairValueListedPrice,
    futureEarnings,
    futureMarketCapitalisation,
    sharePriceFutureYear,
    futureSharesOutstanding,
    exchangeRate,
    timeFrame,
  } = calculationBreakDownOutput;
  const futureEarningsFormatted = toCurrencyTruncated(
    futureEarnings,
    2,
    currencyISO
  );
  const fairValueReportedPriceFormatted = toCurrencyTruncated(
    fairValueReportedPrice,
    2,
    currencyISO
  );
  const futureYear = currentYear + timeFrame;

  const futureYearFormatted = `'${futureYear.toString().slice(-2)}`;
  const currentYearFormatted = `'${currentYear.toString().slice(-2)}`;
  const futureMarketCapFormatted = formatterCurrencyTruncated(
    futureMarketCapitalisation,
    currencyISO
  );
  const sharePriceFutureYearFormatted = toCurrencyTruncated(
    sharePriceFutureYear,
    2,
    currencyISO
  );
  const futureSharesOutstandingFormatted = toTruncated(futureSharesOutstanding);
  const formattedExchangeRate = `${toTruncated(
    exchangeRate,
    4
  )} ${reportingCurrencyISO}/${listingCurrencyISO}`;
  const fairValueListedPriceFormatted = toCurrencyTruncated(
    fairValueListedPrice,
    2,
    listingCurrencyISO
  );

  return {
    fairValueReportedPrice: fairValueReportedPriceFormatted,
    futureMarketCap: futureMarketCapFormatted,
    futureEarnings: futureEarningsFormatted,
    futureYear: futureYearFormatted,
    currentYear: currentYearFormatted,
    sharePriceFutureYear: sharePriceFutureYearFormatted,
    futureSharesOutstanding: futureSharesOutstandingFormatted,
    exchangeRate: formattedExchangeRate,
    fairValueListedPrice: fairValueListedPriceFormatted,
  };
};
